import { useCallback } from 'react';

import { useUserMenuDataShapes } from '../../../../controllers/user-state/user-menu-data-shapes-provider';

export function useNavItemVisibilityActions(itemMenuId: string) {
	const { userMenuData, visibleItemMenuIds, setUserMenuData } = useUserMenuDataShapes();

	const hideItem = useCallback(async () => {
		if (!visibleItemMenuIds.includes(itemMenuId)) {
			return;
		}

		const dataWithHiddenItem = userMenuData.map((datum) => {
			if (datum.menuId === itemMenuId) {
				return {
					...datum,
					visible: false,
				};
			}
			return datum;
		});

		setUserMenuData(dataWithHiddenItem);
	}, [itemMenuId, setUserMenuData, userMenuData, visibleItemMenuIds]);

	const showItem = useCallback(async () => {
		if (visibleItemMenuIds.includes(itemMenuId)) {
			return;
		}

		const dataWithVisibleItem = userMenuData.map((datum) => {
			if (datum.menuId === itemMenuId) {
				return {
					...datum,
					visible: true,
				};
			}
			return datum;
		});

		setUserMenuData(dataWithVisibleItem);
	}, [itemMenuId, setUserMenuData, userMenuData, visibleItemMenuIds]);

	return { hideItem, showItem };
}
